import React from 'react';
import PropTypes from 'prop-types';
import { createTheme, StylesProvider } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { neutral800, functional, form500 } from '@fever/ui';

const commonOverrides = {
    overrides: {
        MuiPaper: {
            root: {
                color: neutral800
            }
        },
        MuiAppBar: {
            colorDefault: {
                color: neutral800
            }
        },
        MuiIconButton: {
            root: {
                color: neutral800
            }
        },
        MuiList: {
            root: {
                color: neutral800
            }
        },
        MuiInputBase: {
            root: {
                color: neutral800
            }
        },
        MuiTab: {
            root: {
                textTransform: 'capitalize !important',
                '&.MuiTab-root': {
                    textTransform: 'capitalize !important'
                }
            },
            label: {
                textTransform: 'capitalize !important'
            }
        },
        MuiButton: {
            root: {
                color: neutral800,
                textTransform: 'capitalize !important'
            },
            label: {
                textTransform: 'capitalize !important'
            }
        },
        MuiTypography: {
            button: {
                textTransform: 'capitalize !important'
            }
        }
    },
    typography: {
        fontFamily: [
            'Noto Sans TC',
            'Noto Sans CJK TC',
            'Roboto',
            'PingFang TC',
            'Helvetica',
            'Arial',
            'sans-serif'
        ].join(','),
        h1: {
            letterSpacing: '-1.5px'
        },
        h2: {
            letterSpacing: '-0.5px;'
        },
        h3: {
            letterSpacing: 'normal'
        },
        h4: {
            letterSpacing: 'normal'
        },
        h5: {
            letterSpacing: '0.18px'
        },
        h6: {
            letterSpacing: '0.15px'
        },
        subtitle1: {
            letterSpacing: '0.15px'
        },
        subtitle2: {
            letterSpacing: '0.1px'
        },
        body1: {
            letterSpacing: '0.5px'
        },
        body2: {
            letterSpacing: '0.25px'
        },
        button: {
            letterSpacing: '1.25px'
        },
        caption: {
            letterSpacing: '0.4px'
        }
    }
};

export const formTheme = createTheme({
    palette: {
        type: 'light',
        primary: {
            main: functional,
            contrastText: '#fff'
        },
        secondary: { main: form500, contrastText: '#fff' }
    },
    ...commonOverrides
});

export function formThemeClient({
    primaryColor,
    secondaryColor,
    textColor,
    fontFamily: i18nFontFamily
}) {
    const { fontFamily, ...variants } = commonOverrides.typography;
    const mergeFontWeight = Object.keys(variants).reduce((obj, key) => {
        obj = { ...obj, [key]: { ...variants[key], fontWeight: 500, color: textColor } };
        return obj;
    }, {});
    return createTheme({
        palette: {
            type: 'light',
            primary: {
                main: primaryColor,
                contrastText: '#fff'
            },
            secondary: { main: secondaryColor }
        },
        typography: {
            fontFamily: i18nFontFamily,
            ...mergeFontWeight
        }
    });
}

function MuiThemeProvider({ children, theme, injectFirst = true }) {
    return (
        <ThemeProvider theme={theme}>
            <StylesProvider injectFirst={injectFirst}>{children}</StylesProvider>
        </ThemeProvider>
    );
}

MuiThemeProvider.propTypes = {
    children: PropTypes.node,
    theme: PropTypes.object
};

export default MuiThemeProvider;
